import BloodPressureClassification from "@/model/BloodPressureClassification";

const backgroundColorForClassification = (classification: BloodPressureClassification) => {
  switch (classification) {
    case "low":
      return "bg-measurement-background-warning";
    case "acceptable":
      return "bg-measurement-background-acceptable";
    case "elevated":
      return "bg-measurement-background-warning";
    case "critical":
      return "bg-measurement-background-emergency";
  }
};

const foregroundColorForClassification = (classification: BloodPressureClassification) => {
  switch (classification) {
    case "low":
      return "text-measurement-text-warning";
    case "acceptable":
      return "text-measurement-text-acceptable";
    case "elevated":
      return "text-measurement-text-warning";
    case "critical":
      return "text-measurement-text-emergency";
  }
};

export { backgroundColorForClassification, foregroundColorForClassification };
